import { useCallback } from 'react';

import { useClearRefinements, useInstantSearch } from 'react-instantsearch';

import { useTracking } from '@change-corgi/core/react/tracking';

type Result = ModelHookResult<
	{
		hideButton: boolean;
	},
	{
		clearRefinements: () => void;
		trackClearFiltersClick: () => void;
	}
>;

export function useClearFilters(): Result {
	const { canRefine, refine } = useClearRefinements();
	const { results } = useInstantSearch();

	const track = useTracking();

	const trackClearFiltersClick = useCallback(() => {
		void track('search_clear_filters_click');
		void track('search', { q: results.query || '', context: 'clear_filters_button' });
	}, [results.query, track]);

	return {
		data: {
			hideButton: !canRefine,
		},
		actions: {
			clearRefinements: useCallback(() => {
				if (canRefine) {
					refine();
				}
			}, [canRefine, refine]),
			trackClearFiltersClick,
		},
	};
}
